var I18n, Optimize, config;

window._ = require('underscore');

window.md5 = require('../../../src/frontend/vendor/md5');

window.Cookie = require('../../../src/frontend/vendor/cookie');

window.Hogan = require('hogan.js');

require('../groupon_modules/modernizr-hacks');

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('optimize-suite');

require('../../../src/frontend/vendor/eventPause-custom');

require('jquery.finger');

window.CartWidget = require('../../../modules/cart_widget/frontend/cart_widget');

window.Fingerprint = require('fingerprintjs');

Optimize = window.Optimize;

config = Optimize.suiteData.config;

config.finch = {
  config: Optimize.finchConfig
};

Optimize.config = config;

OptimizeSuite.init(config);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2NvbW1vbi9jb3JlX2xpYnJhcmllcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL2NvcmUvZnJvbnRlbmQvY29tbW9uL2NvcmVfbGlicmFyaWVzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxDQUFQLEdBQVcsT0FBQSxDQUFRLFlBQVI7O0FBQ1gsTUFBTSxDQUFDLEdBQVAsR0FBa0IsT0FBQSxDQUFRLGtDQUFSOztBQUNsQixNQUFNLENBQUMsTUFBUCxHQUFrQixPQUFBLENBQVEscUNBQVI7O0FBQ2xCLE1BQU0sQ0FBQyxLQUFQLEdBQWUsT0FBQSxDQUFRLFVBQVI7O0FBQ2YsT0FBQSxDQUFRLG9DQUFSOztBQUNBLElBQUEsR0FBTyxPQUFBLENBQVEsMkNBQVI7O0FBQ1AsTUFBTSxDQUFDLElBQVAsR0FBa0IsSUFBQSxJQUFBLENBQUE7O0FBQ2xCLE9BQUEsQ0FBUSxnQkFBUjs7QUFFQSxPQUFBLENBQVEsZ0RBQVI7O0FBQ0EsT0FBQSxDQUFRLGVBQVI7O0FBQ0EsTUFBTSxDQUFDLFVBQVAsR0FBb0IsT0FBQSxDQUFRLG1EQUFSOztBQUNwQixNQUFNLENBQUMsV0FBUCxHQUFxQixPQUFBLENBQVEsZUFBUjs7QUFFcEIsV0FBWTs7QUFDWixTQUFVLFFBQVEsQ0FBQzs7QUFDcEIsTUFBTSxDQUFDLEtBQVAsR0FBZTtFQUFBLE1BQUEsRUFBUSxRQUFRLENBQUMsV0FBakI7OztBQUNmLFFBQVEsQ0FBQyxNQUFULEdBQWtCOztBQUNsQixhQUFhLENBQUMsSUFBZCxDQUFtQixNQUFuQiJ9
